<template>
  <div>
    <el-dialog
      v-if="isShow"
      title="Bulk Create Carriers"
      :visible.sync="isShow"
      top="3vh"
      :close-on-click-modal="false"
      :fullscreen="isFullscreen"
    >
      <div v-if="step === -1">
        <div style="display: flex; justify-content: center;">
          <el-transfer
            id="bulk-create-transfer"
            v-model="transferredCarrierIds"
            v-loading="isLoadingCarriers"
            :titles="['Carriers', 'Creating']"
            :data="modifiedCarriers"
            filterable
            filter-placeholder="Enter Carrier Name"
          />
        </div>
      </div>
      <div v-else>
        <CarrierSettingEditForm
          ref="editForm"
          v-model="carrierSettings[step]"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="isFullscreen = !isFullscreen">
          <FontAwesomeIcon
            v-if="isFullscreen"
            :icon="['fal', 'compress']"
          />
          <FontAwesomeIcon
            v-else
            :icon="['fal', 'expand']"
          />
        </el-button>
        <el-button @click.native="isShow = false">
          Cancel
        </el-button>
        <el-button
          :disabled="step === -1"
          @click.native="step -= 1"
        >
          Previous
        </el-button>
        <el-button
          type="primary"
          :loading="isSaving"
          :disabled="transferredCarrierIds.length === 0"
          @click.native="step === -1 ? startEditCarriers() : nextStep()"
        >
          {{ showSteps }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CarrierSettingEditForm from '@/components/Application/Manage/Account/CarrierSettingEditForm'
export default {
  components: {
    CarrierSettingEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      rawCarriers: [],
      modifiedCarriers: [],
      transferredCarrierIds: [],
      isShow: false,
      isSaving: false,
      isFullscreen: false,
      isLoadingCarriers: false,
      carrierSettings: [],
      step: -1,
      totalSteps: 0
    }
  },
  computed: {
    showSteps () {
      if (this.step !== -1) { // If not first step
        if ((this.step + 1) === this.carrierSettings.length) { // If is last step
          return `Create ${this.step + 1}/${this.totalSteps}`
        } else return `Next ${this.step + 1}/${this.totalSteps}` // If between first and last step
      } else return 'Next' // If first step
    }
  },
  created () {
    this.loadCarriers()
  },
  methods: {
    loadCarriers () {
      this.isLoadingCarriers = true
      this.$sdk.carrier.list(builder => {
        builder.page = 1
        builder.limit = 999
        builder.order = 'name:asc'
      })
        .then(res => {
          this.rawCarriers = res
          this.formatCarriers()
        })
        .finally(() => { this.isLoadingCarriers = false })
    },
    formatCarriers () {
      this.rawCarriers.map(carrier => {
        this.modifiedCarriers.push({
          key: carrier.id,
          label: carrier.name
        })
      })
    },
    startEditCarriers () {
      // Added new carrierSetting to the carrierSettings list
      this.transferredCarrierIds.map(cID => {
        let carrier = this.rawCarriers.find(c => c.id === cID)
        if (this.carrierSettings.findIndex(cs => cs.carrier.id === carrier.id) === -1) {
          let carrierSetting = new this.$sdk.account_carriersetting()
          carrierSetting.carrier = carrier
          this.setDefaultProperties(carrierSetting)
          this.carrierSettings.push(carrierSetting)
        }
      })
      // Remove the carrierSetting from carrierSettings list where carrier already has been removed from the transfer
      this.carrierSettings = this.carrierSettings.filter(cs => this.transferredCarrierIds.findIndex(cID => cID === cs.carrier.id) !== -1)

      this.step = 0
      this.totalSteps = this.carrierSettings.length
    },
    nextStep () {
      this.$refs.editForm.$refs.carrierSettingForm.validate((valid) => {
        if (valid) {
          if (this.step === (this.carrierSettings.length - 1)) {
            this.createCarrierSettings()
          } else this.step += 1
        }
      })
    },
    async createCarrierSettings () {
      this.isSaving = true
      try {
        await Promise.all(this.carrierSettings.map(async cs => {
          await this.$sdk.account_carriersetting.create(cs, builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['carrier']
          })
        }))
      } catch (err) {
        this.$message({ message: `An error occurred while creating`, type: 'error' })
      }
      this.isSaving = false
      this.isShow = false
      this.$emit('created')
      this.$message({ message: 'Successfully created', type: 'success' })
      this.carrierSettings = []
      this.transferredCarrierIds = []
      this.step = -1
      this.totalSteps = 0
    },
    setDefaultProperties (carrierSetting) {
      carrierSetting.active_in_shipper = true
      carrierSetting.carrier_active = true
      carrierSetting.carrier_is_customers = false
      carrierSetting.always_third_party = false
    }
  }
}
</script>

<style lang="scss">
  #bulk-create-transfer .el-transfer-panel {
    width: 280px;
  }
</style>
